// extracted by mini-css-extract-plugin
module.exports = {"item-requested":"styles__item-requested___xp50C","requested-title":"styles__requested-title___2tE0i","icon-check":"styles__icon-check___2ZK7m"};